export const INITIAL_STEP = 0;
export const CONFIRM_CONTACT = 1;
export const CONFIRM_COMPANY = 2;
export const SELECT_COMPANY = 3;
export const CONTACT_SUPPORT = 4;
export const CONFIRM_SHARE = 5;
export const CANCEL_SHARE = 6;
